/**
 *  @class
 *  @function CategorySlider
 */
if (!customElements.get('category-slider')) {
  class CategorySlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.track = this.querySelector('.category-slider__track');
      this.prevButton = this.querySelector('.category-slider__arrow--prev');
      this.nextButton = this.querySelector('.category-slider__arrow--next');

      if (!this.track) return;

      this.prevButton.addEventListener('click', () => this.scrollByAmount(-1));
      this.nextButton.addEventListener('click', () => this.scrollByAmount(1));
      this.track.addEventListener('scroll', () => this.updateButtons());
      window.addEventListener('resize', () => this.updateButtons());

      this.updateButtons();
    }
    scrollByAmount(direction) {
      const item = this.track.querySelector('.category-slider__item');
      const amount = item ? item.getBoundingClientRect().width + 24 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }
    updateButtons() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 1;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
    }
  }

  customElements.define('category-slider', CategorySlider);
}
